// 默认布局使用的多语言

export default {
  "zh-CN": {
    basicLayout: {}
  },
  "en-US": {
    basicLayout: {}
  },
  "alb-AR": {
    basicLayout: {}
  },
  "fa-FR": {
    basicLayout: {}
  },
  "es-ES": {
    basicLayout: {}
  },
  "els-RU": {
    basicLayout: {}
  }
};
